import { useLogin } from "../common/hooks/useUser";
export const useCheckIsAFPSuperAdmin = () => {
  const loginDetails = useLogin();
  const tenantDetails = loginDetails?.tenantDetails;
  const userDetails = loginDetails?.userDetails;
  return (
    tenantDetails?.tenantType === "SuperTenant" &&
    userDetails?.roles?.role === "Super Admin"
  );
};
